import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './AdminDashboard.module.css';
import config from '../config';
import AdminOnboardingUsersTable from './AdminOnboardingUsersTable';
import BrandLogo from './BrandLogo';

const NAV_ITEMS = [
  {
    path: '/admin-categories',
    label: 'Category',
    shortLabel: 'Categories',
    className: 'categories-button',
    icon: 'M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.89 5.01 3 5.9 3 7v10c0 1.1.89 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16z',
  },
  {
    path: '/admin-user-cfp-sessions',
    label: 'CFP Sessions',
    shortLabel: 'CFP',
    className: 'cfp-sessions-button',
    icon: 'M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z',
  },
];

const LOGOUT_ICON =
  'M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.59L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z';

function readAdminInfo() {
  return {
    fullName: localStorage.getItem(config.STORAGE_KEYS.NAME) || 'Admin',
    email: localStorage.getItem('adminEmail') || 'admin@richuel.com',
  };
}

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [adminInfo] = useState(readAdminInfo);

  useEffect(() => {
    if (!localStorage.getItem(config.STORAGE_KEYS.TOKEN)) {
      navigate('/admin-login');
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.clear();
    navigate('/admin-login');
  };

  return (
    <div className={styles['admin-dashboard-container']}>
      <header className={styles['admin-header']} role="banner">
        <div className={styles['header-left']}>
          <BrandLogo to="/admin-dashboard" />
          <div className={styles['header-info']}>
            <h1 className={styles['page-title']}>Onboarding Users</h1>
            <p className={styles['page-description']}>
              Manage users who have completed the onboarding process
            </p>
          </div>
        </div>

        <div className={styles['header-right']}>
          <nav className={styles['nav-actions']} aria-label="Admin sections">
            {NAV_ITEMS.map((item) => (
              <button
                key={item.path}
                type="button"
                className={`${styles['nav-button']} ${styles[item.className]}`}
                onClick={() => navigate(item.path)}
                aria-label={item.label}
              >
                <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden>
                  <path d={item.icon} />
                </svg>
                <span className={styles['nav-label-full']}>{item.label}</span>
                <span className={styles['nav-label-short']}>{item.shortLabel}</span>
              </button>
            ))}
          </nav>
          <div className={styles['header-meta']}>
            <div className={styles['admin-details']}>
              <h2 className={styles['admin-name']}>{adminInfo.fullName}</h2>
              <span className={styles['admin-details-sep']} aria-hidden="true" />
              <p className={styles['admin-email']}>{adminInfo.email}</p>
            </div>
            <button
              type="button"
              className={`${styles['nav-button']} ${styles['logout-button']}`}
              onClick={handleLogout}
            >
              <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden>
                <path d={LOGOUT_ICON} />
              </svg>
              Log out
            </button>
          </div>
        </div>
      </header>

      <main className={styles['admin-main-content']} id="admin-dashboard-main">
        <AdminOnboardingUsersTable />
      </main>
    </div>
  );
};

export default AdminDashboard;
